import * as React from 'react';
import { Svg } from '../svg';

function SvgEmailResend({ title, titleId, ...props }, svgRef) {
  return (
    <Svg
      width="1em"
      height="1em"
      viewBox="0 0 81 80"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      ref={svgRef}
      aria-labelledby={titleId}
      {...props}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <path fill="url(#email-resend_svg__pattern0)" d="M.5 0h80v80H.5z" />
      <defs>
        <pattern
          id="email-resend_svg__pattern0"
          patternContentUnits="objectBoundingBox"
          width={1}
          height={1}
        >
          <use xlinkHref="#email-resend_svg__image0" transform="scale(.0125)" />
        </pattern>
        <image
          id="email-resend_svg__image0"
          width={80}
          height={80}
          xlinkHref="data:image/png;base64,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"
        />
      </defs>
    </Svg>
  );
}

const ForwardRef = React.forwardRef(SvgEmailResend);
export default ForwardRef;
